<template>
  <div class="user camp-member-page">
    <div class="headerbg">
      <b-container class="d-flex align-items-center justify-content-between">
        <h1>{{ title }}</h1>
        <b-button variant="outline-secondary" size="sm" @click="logout"
          >登出</b-button
        >
      </b-container>
    </div>
    <b-container fluid="xl">
      <b-row>
        <b-col cols="12" md="2" class="member-sidebar-col">
          <nacUser></nacUser>
        </b-col>
        <b-col cols="12" md="10" class="member-content-col">
          <b-card class="mb-3">
            <template #header>
              <span class="font-weight-bold">折價券</span>
            </template>
            <b-row class="mb-3" align-v="center">
              <b-col cols="12" md="6" lg="4">
                <b-input-group>
                  <b-form-input
                    v-model.trim="couponCode"
                    maxlength="32"
                    placeholder="輸入折扣碼"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      variant="primary"
                      :disabled="receiving"
                      @click="ReceiveCoupon"
                      >送出</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table
              striped
              hover
              responsive
              :items="items"
              :fields="fields"
              show-empty
              empty-text="目前沒有可用的營隊折價券"
              class="camp-member-table"
            >
              <template #cell(CouponCode)="{ item }">
                <span class="coupon-code">{{ item.CouponCode }}</span>
              </template>
              <template #cell(Period)="{ item }">
                {{ periodText(item) }}
              </template>
              <template #cell(Used)="{ item }">
                <b-badge :variant="couponStatusVariant(item)">
                  {{ couponStatusText(item) }}
                </b-badge>
              </template>
              <template #cell(ReceiveDate)="{ item }">
                {{ dateTimeText(item.ReceiveDate) }}
              </template>
              <template #cell(tool)="{ item }">
                <b-button
                  variant="link"
                  @click="openDetail(item)"
                  v-b-tooltip.hover
                  title="查看詳情"
                >
                  <b-icon icon="eye"></b-icon>
                </b-button>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="coupon-detail-modal"
      title="折價券詳情"
      ok-only
      ok-title="關閉"
    >
      <b-list-group v-if="detailItem">
        <b-list-group-item class="d-flex justify-content-between">
          <span class="text-muted">折價券名稱</span>
          <span>{{ detailItem.CouponName }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <span class="text-muted">折扣碼</span>
          <span class="coupon-code">{{ detailItem.CouponCode }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <span class="text-muted">優惠內容</span>
          <span>{{ discountRuleText(detailItem) }}</span>
        </b-list-group-item>

        <b-list-group-item
          v-if="isPercentDiscount(detailItem)"
          class="d-flex justify-content-between"
        >
          <span class="text-muted">最高折抵</span>
          <span>{{ maxAmountText(detailItem) }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <span class="text-muted">有效期限</span>
          <span>{{ periodText(detailItem) }}</span>
        </b-list-group-item>
        <b-list-group-item class="coupon-applicable-item">
          <span class="text-muted">適用營隊課程</span>
          <div
            v-if="
              !detailItem.ApplicablePrograms ||
                detailItem.ApplicablePrograms.length === 0
            "
            class="coupon-applicable-all"
          >
            全營隊適用
          </div>
          <div v-else class="coupon-applicable-programs">
            <div
              v-for="program in detailItem.ApplicablePrograms"
              :key="program.CampProgramId"
              class="coupon-applicable-program"
            >
              <strong>{{ program.CampProgramName || "未命名營隊" }}</strong>
              <div class="coupon-applicable-products">
                <b-badge
                  v-for="(productName, index) in program.CampProductNames"
                  :key="`${program.CampProgramId}-${index}`"
                  variant="light"
                >
                  {{ productName }}
                </b-badge>
              </div>
            </div>
          </div>
        </b-list-group-item>

        <b-list-group-item
          v-if="descriptionText(detailItem)"
          class="coupon-description-item"
        >
          <span class="text-muted">說明</span>
          <span class="coupon-description">{{
            descriptionText(detailItem)
          }}</span>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import nacUser from "@/components/nacUser.vue";
import { apiGetCampCoupons, apiReceiveCampCoupon } from "@/api/API.js";

export default {
  name: "MyCampCoupon",
  components: { nacUser },
  data() {
    return {
      title: "營隊折價券",
      couponCode: "",
      receiving: false,
      items: [],
      detailItem: null,
      fields: [
        { key: "CouponName", label: "折價券名稱" },
        { key: "CouponCode", label: "折扣碼" },
        { key: "Period", label: "有效期限" },
        { key: "Used", label: "使用狀態" },
        { key: "ReceiveDate", label: "領取時間" },
        { key: "tool", label: "操作" },
      ],
    };
  },
  mounted() {
    if (this.IsNull(this._sessionData("TokenID")) == "") {
      alert("尚未登入");
      this._go("/");
      return;
    }
    this.GetList();
  },
  methods: {
    logout() {
      const data1 = this._storeData("Header_form1");
      if (this.IsNull(data1) !== "") {
        data1.text = "學員登入";
      }
      this._sessionData("NewToken", "");
      this._sessionData("TokenID", "");
      this._sessionData("campCartCachedCount", "");
      this._sessionData("courseCartCachedCount", "");
      this._go("/");
    },
    GetList() {
      this.loadSet.show = true;
      apiGetCampCoupons()
        .then((res) => {
          this.items = res.data || [];
          this.loadSet.show = false;
        })
        .catch((err) => {
          this.loadSet.show = false;
          console.log(err);
        });
    },
    ReceiveCoupon() {
      if (!this.couponCode) return alert("請輸入折扣碼");

      this.receiving = true;
      this.loadSet.show = true;
      apiReceiveCampCoupon({ Code: this.couponCode })
        .then(() => {
          this.couponCode = "";
          alert("折價券領取成功");
          return this.GetList();
        })
        .catch((err) => {
          this.loadSet.show = false;
          alert(
            err.response && err.response.data
              ? err.response.data
              : "折價券領取失敗",
          );
          console.log(err);
        })
        .finally(() => {
          this.receiving = false;
          this.loadSet.show = false;
        });
    },
    openDetail(item) {
      this.detailItem = item;
      this.$bvModal.show("coupon-detail-modal");
    },
    couponStatusText(item) {
      // 已經使用過，優先顯示已使用
      if (item.Used) {
        return "已使用";
      }

      const state = String(item.State);

      if (state === "90") {
        return "已逾期";
      }

      if (state === "10") {
        return "尚未開始";
      }

      if (state === "20") {
        return "未使用";
      }

      return "未知狀態";
    },

    couponStatusVariant(item) {
      if (item.Used) {
        return "secondary";
      }

      const state = String(item.State);

      if (state === "90") {
        return "danger";
      }

      if (state === "10") {
        return "warning";
      }

      if (state === "20") {
        return "success";
      }

      return "secondary";
    },
    discountRuleText(item) {
      const minAmount = Number(item.MinAmount || item.minAmount || 0);
      const value = Number(item.Value || item.value || 0);
      const prefix = minAmount > 0 ? `滿 ${minAmount} 元` : "不限金額";

      if (this.isPercentDiscount(item)) {
        return `${prefix}，享 ${value * 10} 折`;
      }

      return `${prefix}，折 ${value} 元`;
    },
    isPercentDiscount(item) {
      const method = item && (item.Method || item.method);
      return method === "折扣折數" || method === "總折扣折數";
    },
    maxAmountText(item) {
      const maxAmount = Number(item.MaxAmount || item.maxAmount || 0);
      return maxAmount > 0 ? `${maxAmount} 元` : "無上限";
    },
    descriptionText(item) {
      return (item && (item.Description || item.description)
        ? item.Description || item.description
        : ""
      ).trim();
    },
    dateText(value) {
      if (!value) return "";
      return value.substring(0, 10);
    },
    periodText(item) {
      const start = item.Start || item.start;
      const end = item.End || item.end;
      if (!start && !end) return "";
      return `${this.dateText(start)} ~ ${this.dateText(end)}`;
    },
    dateTimeText(value) {
      if (!value) return "";
      return value.substring(0, 16).replace("T", " ");
    },
  },
};
</script>

<style scoped>
.coupon-code {
  font-weight: 600;
  letter-spacing: 0;
}

.coupon-description-item {
  display: block;
}

.coupon-description {
  display: block;
  margin-top: 0.35rem;
  white-space: pre-line;
}

.coupon-applicable-item {
  display: block;
}

.coupon-applicable-all {
  margin-top: 0.5rem;
  padding: 0.65rem 0.8rem;
  border-radius: 6px;
  color: #0878b9;
  background: #eef8fd;
  font-weight: 600;
}

.coupon-applicable-programs {
  margin-top: 0.5rem;
}

.coupon-applicable-program + .coupon-applicable-program {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e5e5e5;
}

.coupon-applicable-products {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.4rem;
}

.coupon-applicable-products .badge {
  padding: 0.45rem 0.6rem;
  border: 1px solid #d7e5ee;
  color: #3e5665;
  font-weight: 400;
}
</style>
